import { render, staticRenderFns } from "./controller.vue?vue&type=template&id=5022f1ef&scoped=true"
import script from "./controller.vue?vue&type=script&lang=js"
export * from "./controller.vue?vue&type=script&lang=js"
import style0 from "./controller.vue?vue&type=style&index=0&id=5022f1ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022f1ef",
  null
  
)

export default component.exports